import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeForbiddenPage, BaSeLoadingPage } from '@base/react';
import { TemplatePage } from './routes/layouts/template';
import { PublicRoutes } from './routes/pages/public';

export const role = {
  administrador: 'ADMIN',
};

export const AdminGuard = ({ children, isAdmin }) => {
  const { isAuthenticated, hasRole, isInitialized, login } = Sebrae.useAuth();
  if (!isInitialized) {
    return <BaSeLoadingPage />;
  }

  if (!isAuthenticated) {
    login();
    return <BaSeLoadingPage />;
  }

  if (isAuthenticated && !hasRole(role.administrador) && isAdmin) {
    return <BaSeForbiddenPage />;
  }
  return children;
};

const FluxoEmpresa = React.lazy(() =>
  import('./pages/selecionar-empresa/index'),
);

const Configuracaopage = React.lazy(() =>
  import('./pages/new-configuracao/configuracao'),
);

const RelatoriosNew = React.lazy(() =>
  import('./pages/new-relatorios/new-relatorios'),
);

const ConsolidadoPage = React.lazy(() => import('./pages/consolidacao-dados'));

const BoletosMeiPage = React.lazy(() =>
  import('./pages/boletos-mei/boletos-mei'),
);

const GestaoChangelog = React.lazy(() =>
  import('./pages/gestao-changelog/gestao-changelog'),
);

const HistoricoVersoes = React.lazy(() =>
  import('./pages/gestao-changelog/historico-versoes'),
);

const indexRoutes = [
  {
    path: '/',
    component: <FluxoEmpresa />,
    isEmpresaSelected: true,
    isAdminActive: false,
  },
  {
    path: '/configuracoes',
    component: <Configuracaopage />,
    isEmpresaSelected: true,
    isAdminActive: false,
  },
  {
    path: '/relatorio',
    component: <RelatoriosNew />,
    isEmpresaSelected: true,
    isAdminActive: false,
  },
  {
    path: '/lancamentos',
    component: <ConsolidadoPage />,
    isEmpresaSelected: true,
    isAdminActive: false,
  },
  {
    path: '/boletos-mei',
    component: <BoletosMeiPage />,
    isEmpresaSelected: true,
    isAdminActive: false,
  },
  {
    path: '/historico-versoes',
    component: <HistoricoVersoes />,
    isEmpresaSelected: false,
    isAdminActive: false,
  },
  {
    path: '/gestao-changelog',
    component: <GestaoChangelog />,
    isEmpresaSelected: false,
    isAdminActive: true,
  },
];

const routes = indexRoutes.map((route) => ({
  pageToRender: (
    <React.Suspense fallback={<BaSeLoadingPage />}>
      <AdminGuard isAdmin={route.isAdminActive}>
        <TemplatePage isEmpresaSelected={route.isEmpresaSelected}>
          {route.component}
        </TemplatePage>
      </AdminGuard>
    </React.Suspense>
  ),
  routePath: route.path,
  isExactPath: true,
}));

export const Routes = () => (
  <Sebrae.Routes routes={[...routes, ...PublicRoutes]} />
);
